import { CellProps, Column } from "react-table"
import { css } from "@emotion/css"
import { Agency } from "models/agency"
import MoreActions from "components/MoreActions"
import { ReactComponent as DeleteIcon } from "assets/delete.svg"
import { Status } from "components/Status"
import { ColorMap } from "utils/color"
import { useI18n } from "providers/I18n"
import { useAuthenticated, Authority } from "providers/A12n"
import { Link } from "components/Link"

const styles = {
  name: css`
    color: var(--primary-main);
  `,
}

export const columns = (
  t: (k: string) => string,
  openDeleteModal: (id: string) => void,
  hasAuthority: (allowed: Authority[]) => boolean,
): Array<
  Column<Agency> & {
    header: string
    fixed?: boolean
    default: boolean
    variant?: string
    sortable?: boolean
  }
> => {
  const market_columns = [
    {
      fixed: true,
      default: true,
      align: "right",
      sortable: false,
      header: "agency.list.actions",
      id: "actions",
      Cell: function (props: CellProps<Agency>) {
        const { id } = props.row.original
        const { hasAuthority } = useAuthenticated()

        return (
          <MoreActions
            options={[
              // DELETE
              {
                hidden: !hasAuthority(["AUTH_EDIT_COMPANY"]),
                label: t("agency.list.delete.action"),
                icon: <DeleteIcon />,
                onClick: () => {
                  openDeleteModal(id)
                },
              },
            ]}
          />
        )
      },
    },
  ]

  let custom_columns = [] as any
  if (!hasAuthority(["AUTH_ACCESS_MARKET_ADMIN"])) {
    custom_columns = market_columns
  }

  return [
    {
      fixed: true,
      default: true,
      sortable: false,
      header: "agency.list.agency",
      id: "name",
      Cell: function (props: CellProps<Agency>) {
        const { id, name } = props.row.original
        const marketUser =
          hasAuthority(["AUTH_ACCESS_MARKET_ADMIN"]) ||
          hasAuthority(["AUTH_ACCESS_MARKET_FINANCE"])

        return (
          <>
            {marketUser ? (
              <Link color="primary" to={`/market-agencies/${id}/profile`}>
                {name}
              </Link>
            ) : (
              <div className={styles.name}>{name}</div>
            )}
          </>
        )
      },
    },
    {
      default: true,
      sortable: false,
      header: "agency.list.status",
      id: "status",
      accessor: "status",
      Cell: function (props: CellProps<Agency>) {
        const { value: status } = props
        const { t } = useI18n()
        return status === null ? null : (
          <Status color={ColorMap[status]}>
            {t(`status.${status ?? ""}`)}
          </Status>
        )
      },
    },
    {
      default: true,
      sortable: false,
      header: "agency.list.code",
      id: "code",
      accessor: "code",
    },
    ...custom_columns,
  ]
}

export const filters = []
export const sortByDefault = "name,ASC"
